import { register } from "async-ops";
import { callMdaeApi } from "../../../../call-web-api";
export const GET_FINDING_GROUP_LIST = "GET_FINDING_GROUP_LIST";

export const service = async (data) => {
  const response = await callMdaeApi({
    url: "/api/v1/finding-groups",
    type: "GET",
  });
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_FINDING_GROUP_LIST, service, mock);
